/* eslint-disable */
import React from 'react';
import { LogoutOutlined, UserOutlined, LockOutlined, DownOutlined } from '@ant-design/icons';
import { Dropdown, Menu } from 'antd';
import { connect } from 'react-redux';
import { signOut } from '../../redux/actions/Auth';
import { APP_PREFIX_PATH } from '../../configs/AppConfig';
import { useNavigate } from 'react-router-dom';
import useCurrentUser from 'src/hooks/useCurrentUser';
import getInitials from 'src/utils/getInitials';

const NavPanel = ({ signOut }: { signOut: any }) => {
  const navigate = useNavigate();
  const { user } = useCurrentUser();
  const handleNavigation = (url: string) => () => {
    navigate(url);
  };

  const menu = (
    <Menu>
      <Menu.Item icon={<UserOutlined />} onClick={handleNavigation(`${APP_PREFIX_PATH}/profile`)}>
        Profile
      </Menu.Item>
      <Menu.Item
        icon={<LockOutlined />}
        onClick={handleNavigation(`${APP_PREFIX_PATH}/change-password`)}
      >
        Change Password
      </Menu.Item>
      <Menu.Item icon={<LogoutOutlined />} onClick={signOut}>
        Log Out
      </Menu.Item>
    </Menu>
  );

  // Real logged-in user's initials for the avatar - no placeholder/fake profile data
  const initials = user?.firstName ? getInitials(user.firstName, user?.lastName || '') : '';

  return (
    <Dropdown overlay={menu}>
      <div className="top-nav-avatar-trigger">
        <span className="top-nav-avatar">{initials}</span>
        {user?.firstName && <span className="top-nav-avatar-name">{user.firstName}</span>}
        <DownOutlined style={{ color: 'rgba(255,255,255,.7)', fontSize: 12 }} />
      </div>
    </Dropdown>
  );
};

const mapStateToProps = ({ theme }: { theme: any }) => {
  const { locale } = theme;
  return { locale };
};

const mapDispatchToProps = {
  signOut,
};

export default React.memo(connect(mapStateToProps, mapDispatchToProps)(NavPanel));
